(() => {
  if (window.ufiB2BLoaded) return;
  window.ufiB2BLoaded = true;
  const rootURL = () => window.Shopify?.routes?.root || '/';
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  function initMenus(scope = document) {
    scope.querySelectorAll('[data-ufi-mega]').forEach(menu => {
      if (menu.dataset.initialised) return;
      menu.dataset.initialised = 'true';
      let closeTimer;
      menu.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { clearTimeout(closeTimer); menu.open = true; } });
      menu.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches) closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180); });
      const categoryLinks = [...menu.querySelectorAll('[data-ufi-category]')];
      function select(link) {
        categoryLinks.forEach(item => item.classList.toggle('is-active', item === link));
        menu.querySelectorAll('[data-ufi-category-panel]').forEach(panel => panel.hidden = panel.dataset.ufiCategoryPanel !== link.dataset.ufiCategory);
      }
      categoryLinks.forEach(link => {
        link.addEventListener('mouseenter', () => select(link));
        link.addEventListener('focus', () => select(link));
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
      document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
    });
  }
  async function quoteApp() {
    for (let i = 0; i < 30; i++) {
      const app = window.sc_raq_app_global;
      if (app && typeof app.set_added_item_list === 'function' && typeof app.get_added_item_list === 'function') return app;
      await sleep(250);
    }
    throw new Error('The quote service is still loading. Please try again, or open your quote list.');
  }
  function selectedVariant(box) {
    if (!box.hasAttribute('data-main-product')) return box.dataset.variant;
    const main = box.closest('[data-form-id]') || box.closest('.m6pr');
    if (!main) return box.dataset.variant;
    const selected = main.querySelector('select[name="id"]') || main.querySelector('input[name="id"]:checked') || main.querySelector('input[name="id"][type="hidden"]');
    return selected?.value || box.dataset.variant;
  }
  function syncVariant(box) {
    if (!box.hasAttribute('data-main-product')) return;
    const data = box.querySelector('[data-quote-variants]');
    if (!data) return;
    const variant = JSON.parse(data.textContent).find(item => String(item.id) === selectedVariant(box));
    if (!variant) return;
    const input = box.querySelector('[data-quote-qty]');
    if (input) {
      input.min = variant.min; input.step = variant.step;
      if (variant.max == null) input.removeAttribute('max'); else input.max = variant.max;
      if (box.dataset.syncedVariant && box.dataset.syncedVariant !== String(variant.id) && !input.validity.valid) input.value = variant.min;
      box.dataset.syncedVariant = String(variant.id);
    }
    const main = box.closest('[data-form-id]') || box.closest('.m6pr');
    const sku = main?.querySelector('[data-ufi-sku]');
    if (sku) { sku.textContent = variant.sku || ''; sku.parentElement.hidden = !variant.sku; }
  }
  document.addEventListener('change', () => setTimeout(() => document.querySelectorAll('[data-main-product][data-ufi-quote]').forEach(syncVariant), 0));
  // Serialize writes because the installed quote app keeps one shared quote list.
  let queue = Promise.resolve();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-add-quote]');
    if (!button) return;
    if (window.ufiCustomerLoggedIn) { event.preventDefault(); return; }
    event.preventDefault();
    if (button.disabled) return;
    const box = button.closest('[data-ufi-quote]'), quantity = box.querySelector('[data-quote-qty]'), status = box.querySelector('.ufi-quote-status');
    syncVariant(box);
    if (!quantity.reportValidity()) return;
    const amount = Number(quantity.value), variant = selectedVariant(box), product = box.dataset.product;
    if (!Number.isSafeInteger(amount) || amount <= 0 || !/^\d+$/.test(variant || '') || !/^\d+$/.test(product || '')) {
      status.textContent = 'Choose a valid product option and whole-number quantity.'; return;
    }
    button.disabled = true;
    status.textContent = 'Adding to your quote…';
    const operation = async () => {
      const app = await quoteApp();
      if (typeof app.raq_chk_prod_basedon_app_settings === 'function') {
        const allowed = app.raq_chk_prod_basedon_app_settings(Number(product), Number(variant), box.dataset.collections || '');
        if (allowed === 0 || allowed === false || allowed === '0') throw new Error('This product is not available for online quotes. Please contact the UFI team.');
      }
      const list = app.get_added_item_list();
      if (!Array.isArray(list)) throw new Error('Your quote could not be loaded. Open your quote list and try again.');
      const existing = list.find(item => String(item.variant_id) === variant);
      const previous = Number(existing?.qty || 0);
      const total = previous + amount;
      if (!Number.isSafeInteger(total)) throw new Error('Please check the quote quantity.');
      const updated = list.map(item => ({...item}));
      const index = updated.findIndex(item => String(item.variant_id) === variant);
      const item = {...existing, variant_id: Number(variant), product_id: Number(product), qty: total};
      if (box.hasAttribute('data-main-product') && document.querySelector('#epo-options .epo-option')) {
        if (typeof app.getEpoValues !== 'function') throw new Error('Please choose your product options using the quote service.');
        const options = app.getEpoValues();
        item.has_additional_product_option = options && Object.keys(options).length ? 1 : 0;
        item.total_extra_option = options || '';
        item.total_extra_price = item.has_additional_product_option && typeof app.sc_epo_calculate_price === 'function' ? app.sc_epo_calculate_price() : '';
      }
      if (index < 0) updated.push(item); else updated[index] = item;
      await Promise.resolve(app.set_added_item_list(updated));
      const saved = app.get_added_item_list();
      const line = Array.isArray(saved) && saved.find(item => String(item.variant_id) === variant);
      if (!line || Number(line.qty) !== total) throw new Error('The quote was not saved. Please open your quote list and try again.');
      if (typeof app.mark_unmark_all_btns_by_added_list === 'function') { try { app.mark_unmark_all_btns_by_added_list(); } catch (_) {} }
      status.textContent = `Added ${amount} to your quote. ${total} in this line.`;
      document.dispatchEvent(new CustomEvent('ufi:quote-updated', {detail: {variantId: variant, quantity: total}}));
    };
    const pending = queue.then(operation);
    queue = pending.catch(() => {});
    pending.catch(error => { status.textContent = error.message || 'Unable to add this product. Please try again.'; }).finally(() => { button.disabled = false; });
  });
  async function initBrandRanges(scope = document) {
    for (const section of scope.querySelectorAll('[data-ufi-more-brand]')) {
      if (section.dataset.loaded) continue;
      section.dataset.loaded = 'true';
      const list = section.querySelector('[data-brand-products]');
      if (list.children.length) continue;
      try {
        const query = 'vendor:"' + section.dataset.vendor.replace(/["\\]/g, '\\$&') + '"';
        const url = new URL(rootURL() + 'search', location.origin);
        url.searchParams.set('q', query); url.searchParams.set('type', 'product'); url.searchParams.set('section_id', 'ufi-brand-results');
        const response = await fetch(url);
        if (!response.ok) throw new Error('Brand range unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const candidates = doc.querySelectorAll('[data-ufi-brand-results] > .product-card');
        for (const card of candidates) {
          const link = card.querySelector('a[href*="/products/"]');
          if (!link || new URL(link.getAttribute('href'), location.origin).pathname.endsWith('/' + section.dataset.currentHandle)) continue;
          list.append(card); if (list.children.length === 6) break;
        }
        if (!list.children.length) section.hidden = true;
      } catch (_) { section.hidden = true; }
    }
  }
  initMenus(); initBrandRanges();
  document.querySelectorAll('[data-main-product][data-ufi-quote]').forEach(syncVariant);
  document.addEventListener('shopify:section:load', event => { initMenus(event.target); initBrandRanges(event.target); event.target.querySelectorAll('[data-main-product][data-ufi-quote]').forEach(syncVariant); });
})();

